import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Example HTTP interceptor for adding auth token
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // TODO: Get token from your auth service
  const token = localStorage.getItem('auth_token');

  if (token) {
    const clonedReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`),
    });
    return next(clonedReq);
  }

  return next(req);
};
